// import clsx from 'clsx';
import EmbedLayout from '@/components/widget/Layout';
import ClientOnly from '@/components/ClientOnly';
import useWidgetConfig from '@/hooks/useWidgetConfig';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const SubscribingWidget = _ref => {
  let {
    widgetId,
    reportingWidgetId
  } = _ref;
  // Load target widget
  const {
    status: widgetStatus,
    data: widget,
    error: widgetError
  } = useWidgetConfig(widgetId);
  const isLoaded = widgetStatus === 'success';
  const hasError = Boolean(widgetError);
  return /*#__PURE__*/_jsx(ClientOnly, {
    children: !hasError && isLoaded && widget ? /*#__PURE__*/_jsx(EmbedLayout, {
      widgetId: widget.id || '',
      reportingWidgetId: reportingWidgetId,
      elementId: widget.elementId,
      config: widget.config,
      sections: widget.sections || {},
      subscriptionActive: widget.subscriptionActive
    }) : hasError ? /*#__PURE__*/_jsx("span", {
      children: "Error, please reload page"
    }) : /*#__PURE__*/_jsx("div", {
      className: styles.loading,
      children: /*#__PURE__*/_jsx("span", {
        children: "Loading"
      })
    })
  });
};

export default SubscribingWidget;